import { SystemEventName } from '../../domain';

export const EVENT_DISPLAY_NAME_FORMATTERS = {
  [SystemEventName.emailSubscribe]: (associatedEntityName: string) =>
    `Subscribed to ${associatedEntityName}`,
  [SystemEventName.emailUnSubscribe]: (associatedEntityName: string) =>
    `Unsubscribed from ${associatedEntityName}`,
};
